import * as React from 'react';

import { Bem } from '../../service/Bem/Bem';

import './PredictorItem.css';

export interface PredictorItemProps {
    title: string;
    value: string[] | string;
}

const BLOCK = 'predictor-item';

export class PredictorItem extends React.Component<PredictorItemProps> {
    render() {
        const { title, value } = this.props;

        return (
            <div className={BLOCK}>
                <div className={Bem.cls(BLOCK, 'value')}>
                    <span className={Bem.cls(BLOCK, 'title')}>{title}</span>
                    {typeof value === 'string' ? value : value.join(',')}
                </div>
            </div>
        );
    }
}
